import React from "react";
import Classes from "./MobileActionBar.module.css";
import { BOOKING_URL, PHONE_TEL } from "../../Pages/ServicePages/serviceData";

// Call / Book buttons pinned to the bottom of the screen on phones (hidden on larger screens).
export default function MobileActionBar() {
    return (
        <nav className={Classes.bar} aria-label="Call or book">
            <a className={`${Classes.btn} ${Classes.call}`} href={PHONE_TEL}>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M6.6 10.8a15.2 15.2 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11.4 11.4 0 0 0 3.6.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1L6.6 10.8z" />
                </svg>
                Call Now
            </a>
            <a className={`${Classes.btn} ${Classes.book}`} href={BOOKING_URL} target="_blank" rel="noreferrer">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H5V10h14v10zM10.6 18.1l-3.1-3.1 1.4-1.4 1.7 1.7 4.5-4.5 1.4 1.4-5.9 5.9z" />
                </svg>
                Book Online
            </a>
        </nav>
    );
}
